import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "survey-show" }

import { onBeforeUnmount, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { surveyStore } from '@/stores/survey'
import PageTitleBar from '@/components/PageTitleBar.vue'
import SurveyDetailsCard from '@/views/survey/cards/SurveyDetailsCard.vue'
import SurveyRelationsCard from '@/views/survey/cards/SurveyRelationsCard.vue'
import SurveyChapterCard from '@/views/survey/cards/SurveyChapterCard.vue'
import SurveyNotesCard from '@/views/survey/cards/SurveyNotesCard.vue'
import SurveySignCard from '@/views/survey/cards/SurveySignCard.vue'
import SurveyIssueTagOverviewCard from '@/views/survey/cards/SurveyIssueTagOverviewCard.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'Survey',
  setup(__props) {

const route = useRoute()
const router = useRouter()

onMounted(() => {
  surveyStore().getSurvey(route.params.surveyId.toString())
})

onBeforeUnmount(() => {
  surveyStore().survey = null
})

function openPdf (url:string) : void {
  window.open(url, '_blank')
}

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(PageTitleBar, null, {
      title: _withCtx(() => [
        _createTextVNode("Keuring " + _toDisplayString(_unref(surveyStore)().survey ? `#${_unref(surveyStore)().survey.id}` : ` - Aan het laden..`), 1)
      ]),
      subtitle: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(surveyStore)().survey?.survey_form ? _unref(surveyStore)().survey.survey_form.reference + ' - ' + _unref(surveyStore)().survey.survey_form.name : ''), 1)
      ]),
      buttons: _withCtx(() => [
        _createVNode(_component_a_button, {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push({ name: 'Surveys' })))
        }, {
          default: _withCtx(() => [
            _createTextVNode("Terug naar overzicht")
          ]),
          _: 1
        }),
        (_unref(surveyStore)().survey?.media.pdf)
          ? (_openBlock(), _createBlock(_component_a_button, {
              key: 0,
              onClick: _cache[1] || (_cache[1] = ($event: any) => (openPdf(_unref(surveyStore)().survey.media.pdf.url)))
            }, {
              default: _withCtx(() => [
                _createTextVNode("Open PDF")
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_a_row, { gutter: [16, 16] }, {
      default: _withCtx(() => [
        _createVNode(_component_a_col, {
          xs: {span: 24},
          sm: {span: 24},
          md: {span: 24},
          lg: {span: 24}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(SurveyDetailsCard)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            (_unref(surveyStore)().survey)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (_unref(surveyStore)().isSurveyOwner && !_unref(surveyStore)().surveyClosed && !_unref(surveyStore)().isSpecialInspection)
                    ? (_openBlock(), _createBlock(_component_a_row, { key: 0 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_col, { span: 24 }, {
                            default: _withCtx(() => [
                              _createVNode(SurveyRelationsCard)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(surveyStore)().survey.survey_form.chapters, (chapter, index) => {
                    return (_openBlock(), _createBlock(_component_a_row, {
                      key: chapter.id
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_col, { span: 24 }, {
                          default: _withCtx(() => [
                            _createVNode(SurveyChapterCard, {
                              chapter: chapter,
                              chapterIndex: index
                            }, null, 8, ["chapter", "chapterIndex"])
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128)),
                  (!_unref(surveyStore)().isSpecialInspection)
                    ? (_openBlock(), _createBlock(_component_a_row, { key: 1 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_col, { span: 24 }, {
                            default: _withCtx(() => [
                              _createVNode(SurveyNotesCard)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(SurveyIssueTagOverviewCard),
                  _createVNode(_component_a_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_col, { span: 24 }, {
                        default: _withCtx(() => [
                          _createVNode(SurveySignCard)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ], 64))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})